
import Bestellung from "@/entities/common/bestellung"
import BestellungenLogic from "@/logic/bestellungen_logic"
import Component, { mixins } from "vue-class-component"
import FilialeHeader from "./custom/FilialeHeader.vue"
import BestellungRow from "./custom/BestellungRow.vue"
import Calculator from "./mixins/Calculator.vue"
import Formatter from "@/logic/formatter"
import ErrorBox from "./custom/ErrorBox.vue"
import ReservierungRow from "./custom/ReservierungRow.vue"
import ReservierungNeu from "@/entities/common/reservierung_neu"
import Identity from "@/entities/common/identity"
import Buchung from "@/entities/common/buchung"

@Component({
  components: { FilialeHeader, BestellungRow, ErrorBox, ReservierungRow },
})
export default class Bestellungen extends mixins(Calculator) {
  logic?: BestellungenLogic = null

  mounted() {
    this.logic = new BestellungenLogic()
    this.logic.init()
  }

  checkReservierung(identity: Identity): ReservierungNeu {
    if (identity instanceof ReservierungNeu) return identity as ReservierungNeu
    return null
  }

  formatiereAbholungStatus(bestellung: Bestellung): string {
    return this.logic.formatiereAbholungStatus(bestellung)
  }

  formatiereLieferungStatus(bestellung: Bestellung): string {
    return this.logic.formatiereLieferungStatus(bestellung)
  }

  computeReservierungZeit(value: Bestellung): string {
    return (
      Formatter.formatiereDatum(value.reservierung.zeitVon) +
      " " +
      Formatter.formatiereUhrzeit(value.reservierung.zeitVon) +
      "-" +
      Formatter.formatiereUhrzeit(value.reservierung.zeitBis)
    )
  }

  detailsAnzeigen(bestellung: Buchung) {
    this.logic.detailsAnzeigen(bestellung as Bestellung)
  }

  reservierungAnzeigen(reservierung: Buchung) {
    this.logic.reservierungAnzeigen(reservierung as ReservierungNeu)
  }

  abgeschlosseneAnzeigen() {
    this.logic.abgeschlosseneAnzeigen()
  }
}
